import { API } from '../Api';

interface WithdrawRequestPayload {
  amount: number;
  bankName: string;
  bankAccountNumber: string;
  bankAccountName: string;
  note?: string;
}

export const createWithdrawRequest = async (payload: WithdrawRequestPayload) => {
  const response = await API.post('/v1/payment-service/transactions/withdraw-requests', payload);
  return response.data;
};

export interface WithdrawFeeEstimate {
  isFirstWithdraw: boolean;
  amountCa: number;
  minCa: number;
  feePercent: number;
  fixedFeeCa: number;
  percentFeeCa: number;
  totalFeeCa: number;
  personalIncomeTaxCa: number;
  netCa: number;
  netVnd: number;
}

// Ước tính phí rút real-time (BE tính, FE chỉ hiển thị bóc tách).
export const estimateWithdrawFee = async (amount: number) => {
  const response = await API.get<WithdrawFeeEstimate>(
    `/v1/payment-service/transactions/withdraw-requests/estimate?amount=${amount}`
  );
  return response.data;
};

// Biểu phí rút tiền công khai (đọc thẳng cấu hình máy chủ) — hiện cho creator đọc trước khi rút.
export interface WithdrawFeeSchedule {
  firstPercent: number;
  repeatPercent: number;
  fixedFeeCa: number;
  minFirstCa: number;
  minRepeatCa: number;
  /** 0 = không giới hạn. */
  maxCa: number;
  vndPerCa: number;
  giftHoldDays: number;
  firstHoldDays: number;
  pitEnabled: boolean;
  pitThresholdCa: number;
  pitRatePercent: number;
}

export const getWithdrawFeeSchedule = async () => {
  const response = await API.get<WithdrawFeeSchedule>('/v1/payment-service/public/withdraw-fee-schedule');
  return response.data;
};

// status rỗng = mọi trạng thái (Submitted | Done | Rejected). Trước đây mặc định chỉ lấy lệnh đang chờ nên lệnh
// đã chi hoặc bị từ chối "biến mất" khỏi lịch sử.
export const fetchWithdrawalHistory = (pageNumber = 1, pageSize = 10, status = '') => {
  return new Promise<any>((resolve, reject) => {
    API.get<any>(
      `/v1/payment-service/transactions/withdraw-requests-by-user?pageNumber=${pageNumber}&pageSize=${pageSize}&status=${status}`,
    )
      .then((response) => resolve(response.data))
      .catch(reject);
  });
};
